<template>
  <div class="home">
    
  </div>
</template>

<script>
import '../assets/css/home.css'
export default {
  data() {
    return {
      isCollapse: false,
    }
  },

  computed: {},

  created() {
    let self = this
  },

  mounted() {},

  methods: {},
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/home.vue